export const transportersSubMenu = [{
  path: '/transporters/list',
  component: () => import('@/views/transporters/list.vue'),
  name: 'Transporter',
  meta: {
    roles: ['Super Admin', 'Admin', 'Read Only', 'Invoice Manager', 'Order Manager'],
    title: 'orderManagement.transporter.title',
    noCache: true,
    icon: 'building'
  }
}, {
  path: '/transporters/edit/:id(\\d+)',
  component: () => import('@/views/transporters/manage.vue'),
  name: 'orderManagement.transporter.edit',
  props: {
    isEdit: true
  },
  meta: {
    title: 'orderManagement.transporter.edit',
    noCache: true,
    activeMenu: '/transporters/list',
    hidden: true
  }
}, {
  path: '/transporters/add/',
  component: () => import('@/views/transporters/manage.vue'),
  name: 'orderManagement.transporter.add',
  props: {
    isEdit: false
  },
  meta: {
    title: 'orderManagement.transporter.add',
    noCache: true,
    activeMenu: '/transporters/list',
    hidden: true
  }
}];